import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { Folder } from '../local-import.entity';
import { FileStatus } from '../local-import.enum';
import { ImportFileInfo } from '../local-import.interface';
import { organizeFiles, trackByForFile, trackByForFolder } from '../local-import.utils';

@Component({
  host: { 'test-id': 'local-import-table' },
  selector: 'local-import-table',
  styleUrls: ['./local-import-table.component.scss'],
  templateUrl: './local-import-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalImportDialogTable implements OnChanges {
  @Input() filesInfo: ImportFileInfo[] = [];

  @Output() readonly cancelFiles = new EventEmitter<ImportFileInfo[]>();
  @Output() readonly retryFiles = new EventEmitter<ImportFileInfo[]>();

  protected readonly trackByForFolderFn = trackByForFolder;
  protected readonly trackByForFileFn = trackByForFile;
  protected folderData: Folder;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filesInfo?.currentValue) {
      this.folderData = organizeFiles(this.filesInfo);
    }
  }

  protected onCancelFolder(folder: Folder): void {
    const files = this._getFilesFromDir(folder);
    this.cancelFiles.emit(files);
  }

  protected onRetryFolder(folder: Folder): void {
    const files = this._getFilesFromDir(folder);
    const failedFiles = files.filter((file) => file.status === FileStatus.Error && !file.isDicomFailure);
    this.retryFiles.emit(failedFiles);
  }

  protected onCancelFiles(files: ImportFileInfo[]): void {
    this.cancelFiles.emit(files);
  }

  protected onRetryFiles(files: ImportFileInfo[]): void {
    this.retryFiles.emit(files);
  }

  private _getFilesFromDir(folder: Folder): ImportFileInfo[] {
    const files: ImportFileInfo[] = [];

    const addFiles = (folder: Folder): void => {
      folder.files.forEach(file => files.push(file));
      const dirs = folder.dirList;
      dirs.forEach((dir) => addFiles(dir));
    };

    addFiles(folder);

    return files;
  }
}
